function detectLocalStorageAvailability() {
  let isAvailable = true
  try {
    localStorage.getItem('test')
  } catch {
    isAvailable = false
  }
  return isAvailable
}

export default {
  isAvailable: detectLocalStorageAvailability(),
  setItem(key, payload) {
    if (!this.isAvailable) return

    try {
      localStorage.setItem(key, payload)
    } catch (e) {
      if (e.name === 'QuotaExceededError' || e.code === 22) {
        console.warn('[triplaLocalStorage] Storage quota exceeded, attempting cleanup')

        try {
          // Remove old reservation entries
          const keysToRemove = []
          for (let i = 0; i < localStorage.length; i++) {
            const storageKey = localStorage.key(i)
            if (storageKey && /^[A-Z0-9]{6,}$/i.test(storageKey) && storageKey !== key) {
              keysToRemove.push(storageKey)
            }
          }
          keysToRemove.slice(0, 5).forEach((k) => localStorage.removeItem(k))

          localStorage.setItem(key, payload)
        } catch (retryError) {
          console.error('[triplaLocalStorage] Failed to save after cleanup')
        }
      }
    }
  },
  getItem(key) {
    if (this.isAvailable) {
      return localStorage.getItem(key)
    }
    return null
  },
  removeItem(key) {
    console.info('[triplaLocalStorage] remove item', key)
    if (this.isAvailable) {
      localStorage.removeItem(key)
    }
  }
}
